import { TInquiryStatus } from '@interfaces/inquiries';
import { IMedicationResponse, IMedicationResponseDetails } from '@interfaces/medications';
import {
  ISupplementResponse,
  ISupplementResponseDetails,
  TSupplementResponseStatus,
} from '@interfaces/supplements';
import { InquiryResponse } from '@models/inquiryResponse';

const updateSupplementStatusToComplete = (
  product: ISupplementResponse | IMedicationResponse,
): ISupplementResponse | IMedicationResponse => ({
  ...product,
  supplementInquiryStatusId: TSupplementResponseStatus.Complete,
});

const hasNoMoreIncompleteSupplements = (
  products: ISupplementResponse[] | IMedicationResponse[],
): boolean =>
  products.every(item => item.supplementInquiryStatusId === TSupplementResponseStatus.Complete);

export const updateInquiryStatusAndListItemStatusToComplete = (
  inquiryResponse: InquiryResponse,
  activeSupplementId: number,
) => {
  const newSupplements = inquiryResponse.supplementInquiriesDto.map(supplement =>
    supplement.supplementInquiryId === activeSupplementId
      ? updateSupplementStatusToComplete(supplement)
      : supplement,
  ) as ISupplementResponse[];

  const newStatus = hasNoMoreIncompleteSupplements(newSupplements)
    ? TInquiryStatus.Complete
    : inquiryResponse.inquiryStatusId;

  return {
    ...inquiryResponse,
    inquiryStatusId: newStatus,
    supplementInquiriesDto: newSupplements,
  };
};

// Lets dublicate the function (similar to above one) to keep it near single responsibility principle and
// to avoid awkward type coercions
export const updateInquiryStatusAndMedicationsStatusToComplete = (
  inquiryResponse: InquiryResponse,
  activeUserEnteredMedicationId: number,
): InquiryResponse => {
  const newMedications = inquiryResponse.medicationInquiriesDto.map(medication =>
    medication.userEnteredMedicationId === activeUserEnteredMedicationId
      ? updateSupplementStatusToComplete(medication)
      : medication,
  ) as IMedicationResponse[];

  const newStatus = hasNoMoreIncompleteSupplements(newMedications)
    ? TInquiryStatus.Complete
    : inquiryResponse.inquiryStatusId;

  return {
    ...inquiryResponse,
    inquiryStatusId: newStatus,
    medicationInquiriesDto: newMedications,
  };
};

export const updateActiveSupplementStatusToComplete = (
  activeSupplementData: ISupplementResponseDetails,
) => ({
  ...activeSupplementData,
  supplementInquiryStatusId: TSupplementResponseStatus.Complete,
});

export const updateActiveMedicationStatusToComplete = (
  activeMedicationData: IMedicationResponseDetails,
): IMedicationResponseDetails => ({
  ...activeMedicationData,
  supplementInquiryStatusId: TSupplementResponseStatus.Complete,
});
